import CustomButton from '@/components/atoms/CustomButton';
import ModalContainer from '@/components/molecules/ModalContainer/ModalContainer';
import useSelectOrganizationContext from '@/hooks/super-admin/useSelectOrganizationContext';
import { Image, Text, VStack } from '@chakra-ui/react';
import React from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  organization: {
    id: string;
    name: string;
    logoUrl?: string;
  } | null;
};

const ConfirmOrganizationSelectionModal = ({ isOpen, onClose, organization }: Props) => {
  const { mutate, isPending } = useSelectOrganizationContext();

  const onConfirm = () => {
    if (organization) {
      mutate({ organizationId: organization.id });
    }
  };

  return (
    <ModalContainer isOpen={isOpen} onClose={onClose} title="Confirm Organization" overflowY="hidden">
      <VStack gap={'30px'}>
        <VStack spacing={'10px'}>
          <Text color={'text.mediumBlue'} fontSize={'20px'}>
            Are you sure you want to select the organization:
          </Text>
          <Text variant={'urbanistSemiBold'} color={'text.mediumBlue'} fontSize={'20px'}>
            {organization?.name} ?
          </Text>
          {organization && organization.logoUrl && (
            <Image
              alt="organization-logo"
              width="100px"
              height="100px"
              src={organization.logoUrl}
              style={{ objectFit: 'cover', borderRadius: '50%' }}
              marginTop={'30px'}
            />
          )}
        </VStack>
        <VStack gap={0}>
          <Text variant={'urbanistTitleMedium'} color={'text.darkBlue'} fontSize={'16px'}>
            This will allow you to access the organization in read-only mode.
          </Text>
          <Text variant={'urbanistTitleMedium'} color={'text.darkBlue'} fontSize={'16px'}>
            Please confirm your selection.
          </Text>
        </VStack>
        <CustomButton onClick={onConfirm} label="Confirm Selection" isLoading={isPending} />
      </VStack>
    </ModalContainer>
  );
};

export default ConfirmOrganizationSelectionModal;
